module.exports = __webpack_public_path__ + "09882d13e3d3d21e60bb74d9f087c4bb.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/proforma-one-source-infinate-solutions.png
// module id = 565
// module chunks = 16